// extracted by mini-css-extract-plugin
export var cdTeamSection = "our-story-module--cd-team-section--a1201";